<template>
  <div class="cookie-disclaimer-container layer-always-on-top">
    <div class="disclaimer-text">
      <p class="pb">
        Nós utilizamos cookies e outras tecnologias para melhorar sua experiência, ao utilizar a Plataforma você concorda com a
        <a href="https://simplificamais.com.br/resources/SIMPLIFICAMAIS-POLITICA-DE-PRIVACIDADE.pdf" target="_blank">
          <b class="pb privacy-policy">
            Política de Privacidade.
          </b>
        </a>
      </p>
    </div>

    <PbButton
      label="Estou ciente"
      button-style="background"
      color="primary"
      class="disclaimer-button"
      @click.native="confirmCookieUsage"
    />
  </div>
</template>

<script>
import { PbButton } from 'vue-polar-bear';

export default {
  name: 'CookieDisclaimer',
  components: {
    PbButton,
  },
  methods: {
    confirmCookieUsage() {
      this.$cookies.set('cookie-policy-accepted', true, Infinity);

      this.$emit('update:closeCookieDisclaimer');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-disclaimer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-shadow: 0px 0px 12px -10px black;
  background-color: var(--color-white);
  position: fixed;
  bottom: 0;
  padding: 20px;
  @media (max-width: 768px) {
    padding: 20px 50px;
    flex-direction: column !important;
  }

  .disclaimer-text {
    display: flex;

    a {
      color: inherit;
    }

    @media (max-width: 768px) {
      margin-bottom: 10px;
      text-align: center;
    }
    .privacy-policy {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .disclaimer-button {
    margin: 0 20px;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
}
</style>
